<template>
    <b-container>
        <b-row>
            <b-col cols="6" lg="3">
                <DateInput v-model="fromDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <DateInput v-model="toDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <b-form-select v-model="filterOption" :options="filterOptions"></b-form-select>
            </b-col>
            <b-col cols="6" lg="3">
                <b-button-group block class="w-100">
                    <b-button @click="getData">{{$t('admin_report.show_report')}}</b-button>
                    <b-button variant="light" @click="exportData">
                        <font-awesome-icon icon="file-export"></font-awesome-icon>
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <BarChart :chart-data="chartData" height="200px"></BarChart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import BarChart from "./BarChart";
    import DateInput from "../DateInput";
    import _ from 'lodash';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faFileExport} from '@fortawesome/free-solid-svg-icons'

    library.add(faFileExport);

    export default {
        name: 'EventApplicationReport',
        components: {DateInput, BarChart},
        data() {
            return {
                fromDate: DateTime.local().startOf('year').toISO(),
                toDate: DateTime.local().endOf('year').toISO(),
                filterOption: {categoryId: null, eventId: null, groupBy: 'category'},
                groupBy: 'category',
                categories: [],
                events: [],
                rawData: null,
            }
        },
        computed: {
            filterOptions() {
                let category = _.concat(
                    [
                        {value: null, disabled: true, text: this.$t('admin_hkiarace.event_category')},
                        {value: {categoryId: null, eventId: null, groupBy: 'category'}, text: this.$t('admin_report.all_categories')},
                    ],
                    this.categories.map(function (c) {
                        return {value: {categoryId: c.id, eventId: null, groupBy: 'category'}, text: c.name};
                    }),
                );

                let event = _.concat(
                    [
                        {value: null, disabled: true, text: this.$t('admin_hkiarace.event')},
                        {value: {categoryId: null, eventId: null, groupBy: 'event'}, text: this.$t('admin_report.all_events')},
                    ],
                    this.events.map(function (e) {
                        return {value: {categoryId: null, eventId: e.id, groupBy: 'event'}, text: e.name};
                    }),
                );


                return _.concat(
                    category,
                    event,
                );
            },
            chartData() {
                if (!this.rawData) {
                    return {}
                }

                let datasets = [];
                let v = this;
                [
                    'application_company',
                    'application_aa_user',
                    'application_non_aa_user',
                    'application_user',
                    'participant_company',
                    'participant_aa_user',
                    'participant_non_aa_user',
                    'participant_user'
                ].forEach(function (t) {
                    let color = 'rgba(' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', 0.5)';

                    let data = v.rawData[t].map(function (d) {
                        // return Math.floor(Math.random() * Math.floor(10));
                        return d.value;
                    });

                    datasets.push({
                        backgroundColor: color,
                        label: v.$t('admin_report.' + t),
                        data: data,
                    });
                });

                let labels = this.rawData['application_company'].map(function (d) {
                    return d.label;
                });

                return {
                    labels: labels,
                    datasets: datasets,
                }
            },
        },
        mounted() {
            this.getCategories();
            this.getEvents();
        },
        watch: {
            fromDate(newValue) {
                if (this.fromDate && this.toDate) {
                    this.getEvents();
                }
            },
            toDate(newValue) {
                if (this.fromDate && this.toDate) {
                    this.getEvents();
                }
            },
        },
        methods: {
            getCategories() {
                this.$callAPI('hkiarace/event_category/', {}, function (response) {
                    this.categories = response.body.categories;
                })
            },
            getEvents() {
                this.$callAPI('hkiarace/admin/event/', {
                    from: DateTime.fromISO(this.fromDate).toSeconds(),
                    to: DateTime.fromISO(this.toDate).toSeconds(),
                }, function (response) {
                    this.events = response.body.events;
                })
            },
            getData() {
                this.$callAPI('hkiarace/admin/report/', {
                    report_type: 'CATEGORY_TOTAL_APPLICATION',
                    params: {
                        from: DateTime.fromISO(this.fromDate).toSeconds(),
                        to: DateTime.fromISO(this.toDate).toSeconds(),
                        category_id: this.filterOption.categoryId,
                        event_id: this.filterOption.eventId,
                        group_by: this.filterOption.groupBy,
                    },
                }, function (response) {
                    this.rawData = response.body.datasets;
                })
            },
            exportData() {
                this.$downloadFile('hkiarace/admin/report/export/', {
                        report_type: 'CATEGORY_TOTAL_APPLICATION',
                        params: {
                            from: DateTime.fromISO(this.fromDate).toSeconds(),
                            to: DateTime.fromISO(this.toDate).toSeconds(),
                            category_id: this.filterOption.categoryId,
                            event_id: this.filterOption.eventId,
                            group_by: this.filterOption.groupBy,
                        },
                    },
                    'export.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            },
        },
    }
</script>

<style>

</style>
